import { render, staticRenderFns } from "./MoFangCloud.vue?vue&type=template&id=5c5f0145&scoped=true"
import script from "./MoFangCloud.vue?vue&type=script&lang=js"
export * from "./MoFangCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f0145",
  null
  
)

export default component.exports